import { BaseAPIModel } from '@weezevent/weezjs-core';

export class EmailLog extends BaseAPIModel {
    fields() {
        return {
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId }) {
        return `/mail/organizations/${organizationId}/messages`;
    }
}
